import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function SelfServeAnalyticsSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-bi-self-serve-analytics")
  return (
    <Container className={className} section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-10 md:mt-0 max-w-2xl mx-auto"
      >
        <Heading
          label="Self-Serve Analytics"
          title="Single analytics platform for your entire organization"
          subtitle={
            <>
              Remove inefficient bottlenecks and empower everyone in your
              organization to answer their own questions. Preset caters to all
              skill levels through a drag-and-drop visual query builder or the
              state-of-the-art SQL Lab.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

SelfServeAnalyticsSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default SelfServeAnalyticsSection
